import { Phone, MessageCircle, Mail, MapPin, Clock, ArrowRight, Instagram } from 'lucide-react';
import useScrollReveal from '../../hooks/useScrollReveal';
import useSeo from '../../hooks/useSeo';
import { useSiteSettings } from '../../context/SiteSettingsContext';

export default function Contact() {
    const revealRef = useScrollReveal();
    const { settings } = useSiteSettings();

    useSeo({
        title: 'İletişim | Noora Privé - Bize Ulaşın',
        description: 'Noora Privé iletişim bilgileri. Sipariş, ürün bilgisi ve stil danışmanlığı için telefon, WhatsApp veya e-posta ile bize ulaşın.',
        keywords: 'Noora Privé iletişim, noora prive iletişim, nooraprive, müşteri hizmetleri, sipariş bilgi, WhatsApp, online butik kadın giyim mağaza, İzmir',
        canonical: 'https://nooraprive.com/iletisim'
    });

    const whatsappLink = settings.whatsapp ? `https://wa.me/${settings.whatsapp}` : '#';
    const phoneLink = settings.phone ? `tel:${settings.phone.replace(/\s/g, '')}` : '#';
    const emailLink = settings.email ? `mailto:${settings.email}` : '#';

    return (
        <div className="np-contact" ref={revealRef}>
            {/* Hero */}
            <section className="np-contact-hero">
                <div className="np-contact-hero-inner">
                    <span className="np-about-overtitle reveal">İletişim</span>
                    <h1 className="reveal">Sizinle Tanışmak<br />İsteriz</h1>
                    <p className="reveal">
                        Sorularınız, önerileriniz veya siparişleriniz için bize ulaşın.
                        Size en kısa sürede dönüş yapacağız.
                    </p>
                </div>
            </section>

            {/* Contact methods */}
            <section className="np-contact-methods">
                <div className="np-contact-methods-inner">
                    <div className="np-contact-method reveal">
                        <div className="np-contact-method-icon">
                            <Phone size={20} />
                        </div>
                        <h3>Telefon</h3>
                        <a href={phoneLink}>{settings.phone || '-'}</a>
                    </div>
                    <div className="np-contact-method reveal">
                        <div className="np-contact-method-icon">
                            <Mail size={20} />
                        </div>
                        <h3>E-posta</h3>
                        <a href={emailLink}>{settings.email || '-'}</a>
                        <span className="np-contact-method-note">24 saat içinde yanıt</span>
                    </div>
                    <div className="np-contact-method reveal">
                        <div className="np-contact-method-icon">
                            <MessageCircle size={20} />
                        </div>
                        <h3>WhatsApp</h3>
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer">Mesaj Gönderin</a>
                        <span className="np-contact-method-note">Hızlı yanıt alın</span>
                    </div>
                    <div className="np-contact-method reveal">
                        <div className="np-contact-method-icon">
                            <MapPin size={20} />
                        </div>
                        <h3>Adres</h3>
                        <span>{settings.address || '-'}</span>
                    </div>
                </div>
            </section>

            {/* Split: CTA left + Map right */}
            <section className="np-contact-split">
                <div className="np-contact-split-left reveal">
                    <span className="np-about-label">Hızlı İletişim</span>
                    <h2>Size Nasıl<br />Yardımcı Olabiliriz?</h2>
                    <p>
                        Sipariş vermek, ürünler hakkında bilgi almak veya
                        beden önerileri için bize yazabilirsiniz.
                    </p>

                    <div className="np-contact-actions">
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="np-contact-action np-contact-action-wa">
                            <MessageCircle size={20} />
                            <div>
                                <strong>WhatsApp ile Yazın</strong>
                                <span>Genellikle birkaç dakika içinde yanıt</span>
                            </div>
                            <ArrowRight size={16} />
                        </a>
                        <a href={phoneLink} className="np-contact-action">
                            <Phone size={20} />
                            <div>
                                <strong>Bizi Arayın</strong>
                                <span>{settings.phone || ''}</span>
                            </div>
                            <ArrowRight size={16} />
                        </a>
                        <a href={emailLink} className="np-contact-action">
                            <Mail size={20} />
                            <div>
                                <strong>E-posta Gönderin</strong>
                                <span>{settings.email || ''}</span>
                            </div>
                            <ArrowRight size={16} />
                        </a>
                    </div>

                    {settings.workingHours && (
                        <div className="np-contact-hours">
                            <Clock size={16} />
                            <span>{settings.workingHours}</span>
                        </div>
                    )}

                    {settings.instagram && (
                        <a href={settings.instagram} target="_blank" rel="noopener noreferrer" className="np-contact-social">
                            <Instagram size={16} />
                            <span>Instagram'da Takip Edin</span>
                        </a>
                    )}
                </div>
                <div className="np-contact-split-right reveal">
                    {settings.mapsEmbedUrl ? (
                        <iframe
                            title="Noora Prive Konum"
                            src={settings.mapsEmbedUrl}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                        />
                    ) : (
                        <div className="np-contact-map-placeholder">
                            <MapPin size={40} />
                            <span>Harita yüklenemiyor</span>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
